var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherHot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9C11.3577 8.98562 10.4863 9.27003 9.77424 9.808C9.06222 10.346 8.55055 11.1066 8.32061 11.9688C8.09068 12.8311 8.15568 13.7455 8.50529 14.5665C8.8549 15.3876 9.46904 16.0682 10.25 16.5M12.25 3V5M6.85 18.4L5.45 19.8M4.25 13H2.25M6.85 7.6L5.45 6.2M20.25 14.5351V4C20.25 2.89543 19.3546 2 18.25 2C17.1454 2 16.25 2.89543 16.25 4V14.5351C15.0544 15.2267 14.25 16.5194 14.25 18C14.25 20.2091 16.0409 22 18.25 22C20.4591 22 22.25 20.2091 22.25 18C22.25 16.5194 21.4456 15.2267 20.25 14.5351Z",
    stroke: "#02222B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherHot);
export default __webpack_public_path__ + "static/media/icon_weather_hot.e1611fe3ea5e3642a5ac52c94607a079.svg";
export { ForwardRef as ReactComponent };